import { useEffect, useState } from "react";
import { Box, Typography, useTheme, Paper, alpha } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import useStyles from "./styles";
import XtermConsole from "../../../../components/HostManager/terminalSSH/XtermConsole";
import api from "../../../../services/api";
import HostInfo from "../../../../components/HostManager/hostInfo/indes";

export default function RemoteAccess() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const {
    setSnackbar,
    selectedCliente: clienteInfo,
    setSelectedCliente: setClienteInfo,
    changed: changedP,
    searchTerm,
    setSearchTerm,
    setChanged: setChangedP,
    serviceFilter,
    setServiceFilter,
    services,
    setServices,
    setValue,
    allServices,
    setAllServices,
    selectedService,
    setSelectedService,
    allService,
    setAllService,
    selectService,
    setSelectService,
    selectStatus,
    setSelectStatus,
    allHostsCliente,
    setAllHostsCliente,
    selectedHost,
    setSelectedHost,
  } = useOutletContext();

  // Seletores
  const [allHosts, setAllHosts] = useState([]);

  // Detalhes do host selecionado
  const [hostDetails, setHostDetails] = useState(null);

  // ERP do cliente aberto (calculado em 2.0-clientes/index.js)
  const { erp } = useOutletContext();

  // 1. Obter identificação de hosts
  useEffect(() => {
    getAllHosts();
  }, []);

  const getAllHosts = async () => {
    try {
      const response = await api.post("/zabbix/hostList");
      setAllHosts(response?.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de hosts:", error);
    }
  };

  // 2. Quando cliente muda, obter serviços
  useEffect(() => {
    setAllServices([]);
    setAllHostsCliente([]);
    setSelectedHost(null);

    if (clienteInfo?.id || clienteInfo?.cnpj || clienteInfo?.clienteErpId) {
      getServicesCliente();
    }
  }, [clienteInfo]);

  const getServicesCliente = async () => {
    try {
      let payload = {};
      if (erp === "HUBSOFT") {
        payload = { cnpj: clienteInfo?.cnpj };
      } else {
        payload = { idClienteErp: clienteInfo?.clienteErpId };
      }
      payload.clienteId = clienteInfo?.id;

      const response = await api.post(
        "/interno/find/allServiceClient",
        payload,
      );

      const services = Array.isArray(response?.data)
        ? response.data.map((item) => ({
            id: item?.id_cliente_servico,
            nome: item?.nome,
            status: item?.status,
            referencia: item?.referencia,
            ownerClienteId: item?.ownerClienteId,
            ownerNome: item?.ownerNome,
          }))
        : [];

      setAllServices(services);

      // Selecionar serviço salvo no localStorage
      const storageData = JSON.parse(localStorage.getItem("filterData"));
      if (String(storageData?.clienteId) === String(clienteInfo?.id)) {
        setSelectedService(
          services.find(
            (s) => parseInt(s?.id) === parseInt(storageData?.serviceId),
          ) || null,
        );
      }
    } catch (error) {
      console.error("Erro ao buscar serviços do cliente:", error);
    }
  };

  // 3. Quando serviço muda, obter hosts
  useEffect(() => {
    setAllHostsCliente([]);
    setSelectedHost(null);
    if (selectedService && allHosts.length > 0) {
      getHostsClient();
    }
  }, [selectedService, allHosts]);

  const getHostsClient = async () => {
    try {
      const response = await api.post("/interno/findMany/hostsCliente", {
        clienteId: clienteInfo?.id,
      });

      const hostsClientesForService = response?.data?.filter(
        (host) =>
          host?.servicoId?.toString() === selectedService?.id?.toString(),
      );

      // Mapear para objetos de host do Zabbix
      const mappedHosts = hostsClientesForService
        ?.map((hostClient) => {
          return allHosts.find(
            (h) =>
              h.hostid === hostClient.hostId ||
              h.host.includes(hostClient.ipOlt),
          );
        })
        ?.filter(Boolean);

      // Remover duplicados
      const uniqueHosts = [
        ...new Map(mappedHosts.map((item) => [item["hostid"], item])).values(),
      ];

      setAllHostsCliente(uniqueHosts);

      // Selecionar host salvo no localStorage
      const storageData = JSON.parse(localStorage.getItem("filterData"));
      if (String(storageData?.clienteId) === String(clienteInfo?.id)) {
        setSelectedHost(
          uniqueHosts.find(
            (h) => parseInt(h?.hostid) === parseInt(storageData?.hostId),
          ) || null,
        );
      }
    } catch (error) {
      console.error("Erro ao buscar hosts do cliente:", error);
    }
  };

  // 4. Quando o host selecionado muda, buscar detalhes do host
  useEffect(() => {
    if (selectedHost?.hostid) {
      getHostDetails(selectedHost.hostid);
    } else {
      // Limpar detalhes ao desselecionar host
      setHostDetails(null);
    }
  }, [selectedHost]);

  const getHostDetails = async (hostId) => {
    try {
      const response = await api.post("/interno/zabbix/getHostDetails", {
        hostId,
      });
      setHostDetails(response?.data || null);
    } catch (error) {
      console.error("Erro ao buscar detalhes do host:", error);
      setHostDetails(null);
    }
  };

  return (
    <Box sx={styles.container}>
      {/* Painel de informações do host*/}
      {selectedHost && <HostInfo hostDetails={hostDetails} />}
      {/* Terminal e informações do host */}
      <Paper elevation={3} sx={styles.paper}>
        {selectedHost ? (
          <XtermConsole
            hostId={selectedHost.hostid}
            token={JSON.parse(localStorage.getItem("user"))?.token}
          />
        ) : (
          <Typography variant="h6" color={theme.palette.colors.gray.light}>
            Selecione um host para conectar ao terminal
          </Typography>
        )}
      </Paper>
    </Box>
  );
}
